import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import Vuex, { Store, ActionTree, ActionContext } from "vuex";
import store from "./store";
import socket from './utils/socket';
import Antd from "ant-design-vue";
import { ServiceStorage } from "src/utils/services"
import "./permission"
import init from "./init"
import VueClipboard from 'vue-clipboard2';
import 'ant-design-vue/dist/antd.less'
import vcolorpicker from 'vcolorpicker'
import VueAMap from "vue-amap";
Vue.use(VueClipboard)
Vue.use(Antd);
Vue.use(vcolorpicker);
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
    // 高德的key
    key: "5de04f0fdc8f7fa470797703b63ca74d",
    // 插件集合
    plugin: ["AMap.Autocomplete", "AMap.PlaceSearch", "AMap.Scale", "AMap.OverView", "AMap.ToolBar", "AMap.MapType", "AMap.Geocoder"],
    // 高德 sdk 版本，默认为 1.4.4
    v: "1.4.4"
});
Vue.use(socket, '/hubs/msghub')

Vue.prototype.$serviceProvier = ServiceStorage.instance;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  created: init,
  render: (h: any) => h(App)
}).$mount("#app");
